<template>
  <div class="page_judge_teams">
    <h1>{{ 'teams' | cz }}</h1>
    <tabloid name="teams" :columns="columns" :data="teams">
      <template v-slot:id="{ row }">
        {{ row | team_name_full }}
      </template>
      <template v-slot:outpostId="{ value }">
        {{ value }}. PH
      </template>
      <template v-slot:category="{ value }">
        {{ value | cz }}
      </template>
      <template v-slot:contactPhone="{ value }">
        {{ value }}
      </template>
      <template v-slot:members="{ value }">
        {{ value.join(', ') }}
      </template>
    </tabloid>
  </div>
</template>
    
<script>
import { _ } from "../../extend";
import tabloid from "../../components/tabloid.vue";

export default {
  name: "judge_teams",
  components: {
    tabloid,
  },
  data: () => ({
    columns: {
      id: { title: "Název" },
      outpostId: { title: "Hlídka" },
      category: { title: "Kategorie" },
      contactPhone: { title: "Telefon" },
      members: { title: "členové" },
    },
  }),
  computed: {
    teams() {
      var highlight = this.$store.state.pathParams.highlight;
      var teams = _.select(this.$store.state.teams, t => ({
        ...t,
        category: t.id.split('-')[0],
        rowAttributes: { class: { 'highlight': highlight == t.id } },
      }));

      return teams
    }
  },
  methods: {
  },
};
</script>
    
<style lang="sass">
@import ../../sass/_constants
@import ../../sass/_components

.page_judge_teams
  @include table-view()

  .tabloid
    .highlight
      background-color: $bc-warning;
</style>